<template>
    <g>
        <transition name="fade">
            <itemSet ref="itemSet" />
        </transition>
        <instructions v-if="this.$store.state.taskContainer.showInstructions" />
        <training v-if="this.$store.state.taskContainer.taskPlaying" />
    </g>
</template>

<script>
import { store } from "@/store.js";
import lang from "@/v/mind_ad/updating_digits/lang.js";
import instructions from "@/v/mind_ad/updating_digits/instructions.vue";
import training from "@/v/mind_ad/updating_digits/training.vue";
import itemSet from "@/v/mind_ad/updating_digits/itemSet.vue";

export default {
    name: "mind_ad_updating_digits",
    //genväg-alias:
    local: store.state.mind_ad_updating_digits,
    components: {
        instructions,
        training,
        itemSet,
    },
    mixins: [lang],
    computed: {
        text() {
            return this.getLocalisedText();
        }
    },
    mounted() {
        //const params = this.calculateParameters(level);
        store.commit("mind_ad_updating_digits_setInstructionsViewed", true);
        store.commit("mind_ad_updating_digits_resetitemSet");
        store.commit("mind_ad_updating_digits_showitemSet");
        
        store.commit("taskPhase", 0);
        store.commit("setTaskMode", "ready");
    }
};
</script>

<style lang="stylus"></style>
